import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Blog.data');

import "./Blog.scss";

// const htmlContent = require("./Blog.html");
import htmlContent from './Blog.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Blog = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Blog
